import { React } from "react";

const Loader = () => {
  return (
    <div className="text-center text-success-700">
      <div className="spinner-border " role="status"></div>
      <p className="font-b2  text-neutral-700">Loading...</p>
    </div>
  );
};

export default Loader;
